import { SET_PRODUCTS, SET_ROUTES } from '.';

export const setRoutesAction = (routes) => ({ type: SET_ROUTES, payload: routes });
export const setProductsAction = (products) => ({ type: SET_PRODUCTS, payload: products });
